// extracted by mini-css-extract-plugin
export default {"container":"Benefit_container__g7lnB","dot-border":"Benefit_dot-border__vftfS"};